var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "EmdFormGroup",
    {
      attrs: {
        label: _vm.$t("document"),
        state: _vm.getState(_vm.$v.recipient.document),
        required: "",
        feedbacks: _vm.feedbacks(_vm.$v.recipient.document),
      },
    },
    [
      _vm.canEdit
        ? _c("EmdInput", {
            attrs: {
              mask: ["###.###.###-##", "XX.XXX.XXX/XXXX-##"],
              name: "document",
              readonly: _vm.disabled,
              disabled: _vm.disabled,
            },
            on: { input: () => _vm.$v.recipient.document.$touch() },
            model: {
              value: _vm.recipient.document,
              callback: function ($$v) {
                _vm.$set(_vm.recipient, "document", $$v)
              },
              expression: "recipient.document",
            },
          })
        : _c("span", [_vm._v(" " + _vm._s(_vm.recipient.document) + " ")]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }